import React from "react";
import { Tabel } from "../../../core";

const columns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
    render: (text, record, index) => <span>{index + 1}</span>,
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    width: 150,
  },
  {
    title: "Quantity (Bags/Cones)",
    dataIndex: "quantity",
    key: "quantity",
    width: 150,
  },
];

const YarnDetail = ({ rows = [] }) => {
  const data = rows.map((row, index) => ({
    ...row,
    key: row.key || index,
    SNo: index + 1,
    quality: row.quality || row.count || "",
    quantity: row.quantity || row.quanity || row.qty || "",
  }));

  return (
    <Tabel pagination={false} nowidth={false} columns={columns} data={data} />
  );
};

export default YarnDetail;
